import { Component, OnInit } from '@angular/core';
import { EmailSettingsService } from './email-settings.service';

// Saved by this page (the rest of api/auto-emails is Appointment Emails & Canned Replies).
const FIELDS = [
    'setting_smtp_host', 'setting_smtp_account', 'setting_smtp_password', 'setting_smtp_port', 'setting_smtp_secure',
    'setting_smtp_from_mail', 'setting_smtp_from_name', 'setting_smtp_reply_mail', 'setting_smtp_reply_name',
    'setting_email_password_reset_subject', 'setting_email_password_reset_body',
    'setting_email_attachment_subject', 'setting_email_attachment_body',
];
// twin-ci required every SMTP field and both subjects.
const REQUIRED = {
    setting_smtp_host: 'SMTP Host', setting_smtp_account: 'SMTP Account', setting_smtp_port: 'SMTP Port',
    setting_smtp_from_mail: 'SMTP From Email', setting_smtp_from_name: 'SMTP From Name',
    setting_smtp_reply_mail: 'SMTP Reply Email', setting_smtp_reply_name: 'SMTP Reply Name',
    setting_email_password_reset_subject: 'Subject: Password Reset',
    setting_email_attachment_subject: 'Subject: Sent Report/Document Attached',
};

/**
 * Settings > Communications > SMTP Settings (mockup settings #smtpPanel): the SMTP credentials and
 * the system generated emails (password reset, documents attached). Split from the old Auto
 * Emails page; same fields and rules (api/auto-emails).
 */
@Component({
    selector: 'app-smtp-settings',
    templateUrl: './smtp-settings.component.html',
    styleUrls: ['./auto-emails.component.scss']
})
export class SmtpSettingsComponent implements OnInit {
    secureOptions = [{ value: 'tls', label: 'TLS' }, { value: 'ssl', label: 'SSL' }, { value: '', label: 'None' }];

    form: any = null;
    passwordSet = false;
    errors: { [field: string]: string } = {};
    loadError = '';
    error = '';
    saved = false;
    saving = false;

    constructor(private emails: EmailSettingsService) { }

    ngOnInit() {
        this.load();
    }

    /** Cancel: back to the saved values. */
    load() {
        this.errors = {};
        this.error = '';
        this.saved = false;
        this.emails.load().subscribe(
            res => {
                this.passwordSet = res.passwordSet;
                const form = res.values;
                form.setting_smtp_password = '';
                // Keep a value twin-ci saved as free text (it was a text box there) instead of changing it.
                const secure = form.setting_smtp_secure;
                if (!this.secureOptions.some(o => o.value === secure)) {
                    this.secureOptions = this.secureOptions.concat({ value: secure, label: secure });
                }
                this.form = form;
            },
            err => this.loadError = typeof err === 'string' ? err : 'The email settings could not be loaded.'
        );
    }

    save() {
        const f = this.form;
        const e = this.emails.blanks(f, REQUIRED);
        const port = Number(f.setting_smtp_port);
        if (!e.setting_smtp_port && !(Number.isInteger(port) && port >= 1 && port <= 65535)) {
            e.setting_smtp_port = 'Enter a port from 1 to 65535.';
        }
        const email = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
        ['setting_smtp_from_mail', 'setting_smtp_reply_mail'].forEach(k => {
            if (!e[k] && !email.test(String(f[k]).trim())) { e[k] = 'Enter a valid email address.'; }
        });
        this.errors = e;
        this.saved = false;
        this.error = '';
        if (Object.keys(e).length) {
            this.error = 'Check the highlighted fields.';
            return;
        }
        const fields: any = {};
        FIELDS.forEach(k => fields[k] = f[k]);
        this.saving = true;
        this.emails.save(fields).subscribe(
            () => {
                this.saving = false;
                this.saved = true;
                if (f.setting_smtp_password) {
                    this.passwordSet = true;
                    f.setting_smtp_password = '';
                }
            },
            err => {
                this.saving = false;
                this.error = typeof err === 'string' ? err : 'The email settings could not be saved.';
            }
        );
    }
}
